import ApplicationLogo from '@/Components/ApplicationLogo'
import patinajeImg from '../../../images/patinaje.jpg'
import cumpleanosImg from '../../../images/cumpleao.jpg'
import React from 'react'
import { Link } from '@inertiajs/inertia-react'

const Services = ({store, branchOffice}) => {
    return (
        <div className="bg-gray-100" style={{ height: "100vh" }}>
            <div className="text-center">
                <ApplicationLogo className="mx-auto" store={store} />
                <div className="pb-20 pt-10">
                    {/* <h1 className="text-lg">Ven a divertirte al mejor parque de patinaje de todo Chile. Lorem ipsum...</h1> */}
                    <h2 className="text-2xl font-bold">Selecciona un servicio.</h2>

                </div>
            </div>
            <div className="grid grid-cols-2 gap-5 max-w-2xl mx-auto">
                <Link href={`/patinaje`} className="rounded-xl relative overflow-hidden text-center bg-white transform scale-100 hover:scale-110 transition duration-500 cursor-pointer">
                    <img className="w-full z-10 " src={patinajeImg} alt="" />
                </Link>

                <Link href={`/cumpleanos`} className="rounded-xl relative overflow-hidden text-center bg-white transform scale-100 hover:scale-110 transition duration-500 cursor-pointer">
                    <img className="w-full z-10" src={cumpleanosImg} alt="" />
                </Link>

            </div>
        </div>
    )
}

export default Services
